export default __webpack_public_path__ + "static/media/x-icon.783fec4d.svg";